<mat-form-field class="d-flex">
    <mat-select [(value)]="sectionSelectionnee"
        (selectionChange)="onSectionChangee($event)"
        class="tour-interactif-step-list">
        <mat-option *ngFor="let entry of sections"
            [value]="entry.value">{{entry.label}}</mat-option>
    </mat-select>
</mat-form-field>

<button style="display: none;"
    class="tour-interactif-step-0"
    (click)="sectionSelectionnee=0"></button>
<button style="display: none;"
    class="tour-interactif-step-1"
    (click)="sectionSelectionnee=1"></button>
<button style="display: none;"
    class="tour-interactif-step-2"
    (click)="sectionSelectionnee=2"></button>

<div class="tour-interactif-sigt-recherche-rde-container">
    <app-droits-contraintes *ngIf="
    sectionSelectionnee===0"></app-droits-contraintes>
    <app-transactions-amendements *ngIf="sectionSelectionnee === 1"></app-transactions-amendements>
    <app-transfert-autorite *ngIf="sectionSelectionnee === 2"></app-transfert-autorite>
</div>
<mat-divider></mat-divider>

<div class="m-h-12 m-v-8">
  <h3>{{ 'sigt.integration.rechercheGdf.form.recherche.titreListeResultats' | translate }}</h3>
  <div *ngIf="rdeResults !== null && rdeResults.length > 0">
    <button class="deleteBtn"
      mat-icon-button
      color="warn"
      tooltip-position="below"
      matTooltipShowDelay="500"
      [matTooltip]="Supprimer"
      [disabled]="!selection.hasValue() || selection.length === 0"
      (click)="deleteResults()">
      <mat-icon>delete</mat-icon>
    </button>
    <mat-divider></mat-divider>
  </div>

  <table mat-table
    id="resultatsRDETable"
    [dataSource]="resultatsTableDataSource">
    <ng-container matColumnDef="select">
      <th mat-header-cell
        *matHeaderCellDef>
        <mat-checkbox (change)="$event ? toggleAllRows() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
          [aria-label]="checkboxLabel()">
        </mat-checkbox>
      </th>
      <td mat-cell
        *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
          [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>
    <ng-container matColumnDef="nomCouche">
      <th mat-header-cell
        *matHeaderCellDef
        mat-sort-header></th>
      <td mat-cell
        *matCellDef="let row"> {{row.nomCouche}} </td>
    </ng-container>
    <ng-container matColumnDef="grille">
      <th mat-header-cell
        *matHeaderCellDef></th>
      <td mat-cell
        *matCellDef="let row">
        <button mat-icon-button
          color="primary"
          aria-label="Ouvrir la grille de résultat de cette couche"
          (click)="ouvrirGrille(row)">
          <mat-icon>table</mat-icon>
        </button>
      </td>
    </ng-container>
    <tr mat-header-row
      *matHeaderRowDef="colonnesTableResultats"></tr>
    <tr mat-row
      *matRowDef="let row; columns: colonnesTableResultats"></tr>
  </table>

</div>